export default __webpack_public_path__ + "static/media/test-grey.d22e0766.svg";